import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-bottom text-white py-4" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-12 col-md-6 text-center text-md-left\"><span class=\"font-weight-bold\">Copyright © 2020 IWARI. Lima, Perú</span></div><div class=\"col-12 col-md-6 text-center text-md-right\"><small><i class=\"fa fa-globe\"></i> Elaborado por <a class=\"text-primary\" href=\"https://globoazul.pe\" target=\"_blank\">Globo Azul</a></small></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}